<template>
  <a-modal
    :visible="visible"
    width="450px"
    :body-style="bodyStyle"
    centered
    :footer="null"
    @cancel="handleCloseModalHeader"
  >
    <div class="container__inactive">
      <img
        class="image__inactive"
        src="@/app/users/assets/profiles/question-circle.png"
        alt="question"
      />
      <p class="text__alert">¿Estás seguro de inactivar a</p>
      <p class="text__alert">“{{ record.first_name }} {{ record.last_name }}”?</p>
    </div>
    <div class="container__info">
      <p class="text">Sucederán las siguientes acciones:</p>
      <ul>
        <li>Se desactivará de estrategias, colas y campañas a las que esté asociado.</li>
        <li>
          Todos los tickets activos se reenviarán a su cola respectiva para que sean atendidos.
        </li>
        <li>
          Se quitara de la lista de usuarios y no se cobrará este usuario en la siguiente
          facturación.
        </li>
      </ul>
    </div>

    <div class="button__disabled">
      <a-button style="width: 100%" class="footer__next" type="primary" @click="handleCloseModal">
        Inactivar usuario
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent } from "vue";
import { UserStatus } from "@/app/shared/utils/enums";

export default defineComponent({
  name: "InactiveUserModal",
  props: {
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const bodyStyle = {
      height: "430px",
      loading: false,
    };

    return {
      bodyStyle,
    };
  },
  data() {
    return {
      UserStatus,
    };
  },
  methods: {
    handleCloseModal() {
      this.$emit("onCancel");
      this.updateStatus();
    },
    handleCloseModalHeader() {
      this.$emit("onCancel");
    },
    async updateStatus() {
      try {
        const body = {
          status: UserStatus.inactive,
        };
        await this.$store.dispatch("updateUser", {
          id: this.record.id,
          params: body,
        });
        this.$emit("update");
      } catch (error) {
        this.$message.error("El correo ya se encuentra registrado", 10);
      }
      this.$emit("onCloseModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.image__inactive
  margin-bottom: 10px
  margin-top: 10px

.text__alert
  font-size: 16px
  font-weight: 600
  margin: 0

.button__disabled
  margin-top: 10px

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center
  color: $gray-13

.container__info
  margin-bottom: 18px
  color: $gray-8

.text
  margin-top: 20px
  margin-bottom: 12px
</style>
